export default __webpack_public_path__ + "static/media/google-teal.ae7c7123.svg";